import script from "./ScanQR.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScanQR.vue?vue&type=script&setup=true&lang=ts"

import "./ScanQR.vue?vue&type=style&index=0&id=10046e8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10046e8c"]])

export default __exports__